import React from 'react';
import { useDashboardPermissions } from '@components';
import { useCreatorSupportChannelsQuery } from '@queries/useCreatorSupportQuery';
import { BookACallButtons } from '@modules/Dashboard/Home/modules/recommendations/useBookACallRecommendation/BookACallButtons';
import bookACallImg from '../assets/book-a-call.png';
export const useBookACallRecommendation = () => {
    const { hasPermission } = useDashboardPermissions();
    const { getCreatorSupportChannelsQuery } = useCreatorSupportChannelsQuery();
    const isVisible = hasPermission('bookACall') &&
        getCreatorSupportChannelsQuery.isSuccess &&
        (!!getCreatorSupportChannelsQuery.data?.calendarUrl ||
            !!getCreatorSupportChannelsQuery.data?.email);
    const response = getCreatorSupportChannelsQuery?.data;
    // NOTE: if you need in the future to use "GUIDED" creator logic, there is
    // const headline = response?.name === 'GUIDED' ? GUIDED_CALL_HEADLINE : NDR_HEADLINE
    return {
        bookACallRecommendation: {
            id: 'bookACall',
            enabled: isVisible,
            suggestionProps: {
                type: 'props',
                props: {
                    title: 'Connect with your dedicated account manager',
                    description: 'Book a call or email us. We’ll make sure you’re set up for success as you grow your creator business',
                    analytics: 'bookACall',
                    imageUrl: bookACallImg,
                    content: React.createElement(BookACallButtons, { calendarUrl: response?.calendarUrl, email: response?.email }),
                },
            },
        },
    };
};
